import './Accordion.less';

import React, { FC, useState, useEffect } from 'react';
import clsx from 'clsx';
import { ArrowSvg } from '../../Arrows/Arrows';
import { ErrorBoundary } from '../../../common/ErrorBoundary';

const Accordion: FC<{
    content;
    children: any;
    onClick?: any;
    arrowSize?;
    arrowColor?;
    otherClass?: string;
    accordionClass?;
    defaultExpanded?: boolean;
    isTournamentCollapsed?: boolean;
    dataAtid?: string;
}> = ({
    content,
    children,
    onClick,
    arrowSize = '16',
    arrowColor = 'c-white',
    otherClass = 'bg-white-ng py-15',
    accordionClass,
    defaultExpanded = true,
    isTournamentCollapsed,
    dataAtid
}) => {
    // onClick a isTournamentCollapsed sa pouziva iba z overview, kde sa pracuje s turnajmi a ich ukladanim do local storage
    const [expanded, setExpanded] = useState(onClick ? !isTournamentCollapsed : defaultExpanded);
    const [visible, setVisible] = useState(onClick ? !isTournamentCollapsed : defaultExpanded);
    const toggle = () => {
        if (onClick) {
            onClick();
        } else {
            setExpanded(prevExpanded => !prevExpanded);
            setTimeout(() => {
                setVisible(!visible);
            }, 200);
        }
    };

    useEffect(() => {
        if (isTournamentCollapsed !== undefined) {
            setExpanded(!isTournamentCollapsed);
            setTimeout(() => {
                setVisible(!isTournamentCollapsed);
            }, 200);
        }
    }, [isTournamentCollapsed]);

    return (
        <ErrorBoundary description="TurboLive Accordion">
            <div
                className={clsx(otherClass, 'accordion-header flex items-center c-white pointer')}
                onClick={toggle}
                tabIndex={1}
                data-atid={dataAtid ? `${dataAtid}-header` : null}
            >
                {content}
                <div className="accordion-placeholder" />
                <ArrowSvg
                    sizeX={arrowSize}
                    sizeY={arrowSize}
                    otherClassName={clsx(arrowColor, 'p-abs accordion-arrow', {
                        'arrow-up': expanded
                    })}
                />
            </div>
            {children && (
                <div
                    className={clsx(accordionClass, 'accordion-view', {
                        'accordion-view-expanded': expanded,
                        'accordion-view-visible': visible
                    })}
                    data-atid={dataAtid}
                >
                    {visible && children}
                </div>
            )}
        </ErrorBoundary>
    );
};

export default Accordion;
